import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;

  font-family: digital;
  font-size: 1.25rem;

  > * {
    width: 1rem;
  }
`;

export const Face = styled.button`
  font-size: 1.25rem;
`;

export const Timer = styled.span``;
